<template>
  <div>
    <div
        v-if="showModal"
        class="s-popup-call"
        :style="{ top: '81vh' , width: '430px', right: '20px' }"
    >
      <v-card class="text-center popup-call">
        <v-card-title class="font-weight-bold mb-0 d-flex justify-space-between">
          <h3 style="font-size: 14px">Cuộc gọi  <span v-show="showTimer">{{ minutes }} : {{ seconds }}</span></h3>
          <v-btn
              v-if="!showEndCall"
              color="default"
              @click="closeModal"
              class="text-right"
              icon
              small
          >
            <v-icon aria-label="Close">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <template v-if="errorMessage">
          <v-alert
              class="mx-4 pa-3 mb-0"
              type="error"
          >
            {{ errorMessage }} {{ currentExt ? `(${currentExt})` : '' }}
          </v-alert>
        </template>
        <v-card-text class="px-6 pt-0 pb-3">
          <div class="row align-center">
            <div class="col-md-9 text-left py-0 pr-0">
              <div class="d-flex">
                <label class="font-weight-bold">Số điện thoại :</label> <strong class="pl-1">{{ maskedPhoneNumber(mobile) }}</strong>
              </div>
              <div class="d-flex">
                <label class="font-weight-bold" style="min-width: 75px">Trạng thái :</label>
                <span>{{ callStatus }} {{ currentExt && currentExt !== '-' ? `(${currentExt})` : '' }}</span>
              </div>
            </div>
            <div class="col-md-3 py-0 pr-0">
              <v-btn class="btn-voice-call ma-0" color="success" fab medium @click="executeCall(0)" v-if="callAgain">
                Gọi
              </v-btn>
              <v-btn class="btn-voice-call ma-0" color="primary" fab medium @click="endSession()" v-if="callWait">
                Kết thúc
              </v-btn>
              <v-btn class="btn-voice-call ma-0" color="primary" fab medium @click="endCall" v-if="showEndCall">
                Kết thúc
              </v-btn>
              <v-btn class="btn-voice-call ma-0" color="success" fab medium @click="acceptCall" v-if="confirmAnswer">
                Trả lời
              </v-btn>
            </div>
          </div>
        </v-card-text>

        <v-dialog
            v-if="showConfirm"
            v-model="showConfirm"
            persistent
            max-width="525"
        >
          <common-confirm-call
              :showCreateAppointment="showCreateAppointment"
              :mobile="mobile"
              :dataAppointment="dataAppointment"
          />
        </v-dialog>
      </v-card>
    </div>
    <v-dialog
        v-if="!isInTheSameCall"
        v-model="warningTenMinutesCall"
        :hide-overlay="true"
        persistent
    >
      <div
          class="s-popup-warning-call"
          style="background: #FFFFFF; border-radius: 8px"
          :style="{ top: '5vh' , width: '450px', right: '20px', height: '70px',}"
      >
        <v-alert
            border="right"
            colored-border
            type="error"
            elevation="2"
        >
          <p class="warning-ten-minutes-call-text"> Cuộc gọi của bạn đã kéo dài quá 10 phút. Bám sát kịch bản tư vấn và sớm kết thúc cuộc gọi nhé !</p>
        </v-alert>
      </div>
    </v-dialog>
  </div>
</template>

<script>
    // import JsSIP from '../../assets/js/jssip-3.3.11.min.js'
    import {maskedPhoneNumber} from "@/helpers/regex";
    import {v1 as uuidv1} from 'uuid'
    import JsSIP from 'jssip'
    import TokenService from "../../helpers/token";
    import { odsService } from "../../helpers/OdsService";
    import { STATUS_SUBIZ_ENDED } from "../../helpers/constants"
    import RepositoryFactory from '../../repositories/RepositoryFactory'
    const ContactRepository = RepositoryFactory.get('contact')
    const CallRepository = RepositoryFactory.get('call_center')
    import axios from 'axios'
    import { mapMutations, mapState  } from 'vuex'
    import moment from 'moment';
    import {USERS_SAVE_LOG} from "@/constants/common";
    const MOBILE_REGEX = new RegExp(/^(0|\+84)((3[2-9])|(4[0-9])|(5[0-9])|(7[0-9])|(8[1-9])|(9[0-46-9]))(\d)(\d{3})(\d{3})$/);
    const BUSY = 'busy';
    const FREE = 'free';
    const SubizWebPhone = require('@subiz/wsclient/webphone.js');

    export default {
        name: 'VoiceCall',
        data() {
            return {
                csVoice: {},
                currentSipCallId: '',
                contactData: {},
                userEndCall: false,
                speechError: '',
                runtimeTranscription_: "",
                transcription_: [],
                lang_: "vi-VN",
                recognition: null,
                showModal: false,
                callError: false,
                session: false,
                isFinish: false,
                configuration: {},
                callPhone: null,
                callStatus: null,
                showEndCall: false,
                callAgain: false,
                isSetting: false,
                callSuccessEnd: false,
                callWait: false,
                errorMessage: '',
                showConfirm: false,
                mobile: '',
                dataAppointment: {},
                appointmentId: null,
                showCreateAppointment: true,
                timer: '',
                minutes: '00',
                seconds: '00',
                showTimer: false,
                contactId: '',
                callStatusCareSoft: '',
                statusChange: '',
                callcenter_id: 0,
                session_call: false,
                confirmAnswer: false,
                isInCall: false,
                store: '',
                acceptCallStatus: false,
                callCenterIdFromApiExt: 0,
                currentExt: '',
                currentGroupId: '',
                warningTenMinutesCall: false,
                isInTheSameCall: false,
                webphone: null,
                STATUS_SUBIZ_ENDED,
                subizInint: '',
                flagHistory: 0,
                timeCallStart : null,
                saveLogInterval: null,
                uuid: '',
            }
        },
        watch: {
            'csVoice.callInfo.callId'(val) {
                if (val) {
                    try {
                        this.currentSipCallId = val;
                        ContactRepository.saveSipCallId({
                            callCenterId: 2,
                            sipCallId: val,
                            mobile: this.mobile,
                            userId: parseInt(TokenService.getId()),
                            url: window.location.href,
                            infoEndUser: {
                                type: 'KH',
                                code: this.contactData.contactCode,
                            }
                        })
                    } catch (e) {
                        console.log(e)
                    }
                }
                console.log(val, 'call id caresoft');
            },
            callStatusCareSoft: {
                deep: true,
                async handler(newVal) {
                  try {
                    let userLog = TokenService.getUser();
                    console.log('callStatusCareSoft val ' + newVal)
                    if (newVal == 'Call ringing') {
                      this.callStatus = 'Bắt đầu gọi ' + maskedPhoneNumber(this.mobile) + ', đợi trả lời!'
                      this.callWait = true
                    }
                    else if (newVal == 'Accept call') {
                      try {
                        this.timeCallStart = moment().format('YYYY-MM-DD HH:mm:ss');
                        this.startRecordingSpeech()
                        // this.recognition.start();
                      } catch (e) {
                        console.log(e)
                      }
                      this.createTimer()
                      this.callStatus = 'Đang bắt đầu cuộc gọi'
                      this.showEndCall = true
                      this.callSuccessEnd = true
                      this.callWait = false
                      this.acceptCallStatus = true
                      Bus.$emit('set-in-call-status')
                    }
                    else if (newVal == 'End call') {
                      console.log('end call caresoft');
                      let closed = true
                      if (this.callWait) {
                        closed = false
                      }
                      clearInterval(this.timer)
                      clearInterval(this.statusChange)
                      if (this.callSuccessEnd && this.appointmentId) {
                        this.callSuccessEnd = false
                        this.callWait = false
                        this.showConfirm = false
                      }
                      this.callStatus = "Kết thúc cuộc gọi"
                      this.userEndCall = true;
                      try {
                        this.recognition.stop()
                      } catch (e) {
                        console.log(e)
                      }
                      this.callAgain = false
                      this.showEndCall = false
                      this.callWait = false
                      this.confirmAnswer = false
                      if (this.contactId) {
                        let description = ''
                        if (this.acceptCallStatus) {
                          description = `${this.isAutoCall ? '(AutoCall) ' : ''}Thực hiện cuộc gọi thành công`
                        } else {
                          description = `${this.isAutoCall ? '(AutoCall) ' : ''}Thực hiện cuộc gọi lỡ.`
                        }
                        await Promise.all([
                          ContactRepository.additionToNumberOfCall(this.contactId, this.store),
                          ContactRepository.createContactHistory({
                            action: 'APPOINTMENT',
                            description: description,
                            contactId: this.contactId,
                            typeCall: this.isDefaultAuto ? 'auto' : this.selectedCallOptions && this.selectedCallOptions.type == 'auto' ?
                              'auto' : 'manual'
                          }, this.contactId),
                        ])
                      }
                      this.acceptCallStatus = false;
                      if (closed) {
                        setTimeout(() => {this.closeModal()}, 3000)
                      } else {
                        this.callAgain = true
                      }

                      // Gọi api set máy lẻ free
                      ContactRepository.updateStatusExtForUser({
                        callcenterId: this.callCenterIdFromApiExt,
                        status: FREE,
                        ext: this.currentExt,
                        groupId: this.currentGroupId
                      })
                    }
                    else if (newVal == 'error') {
                      // console.log('retry call caresoft');
                      this.errorMessage = "Cuộc gọi không thành công"
                      this.showEndCall = false
                      this.callSuccessEnd = false
                      this.callWait = false;
                      // Bus.$emit('check-retry-call')
                      // Gọi api set máy lẻ free
                      ContactRepository.updateStatusExtForUser({
                        callcenterId: this.callCenterIdFromApiExt,
                        status: FREE,
                        ext: this.currentExt,
                        groupId: this.currentGroupId
                      })
                    }
                    else if (newVal == 'failed') {
                      // console.log('retry call caresoft2');
                      this.callAgain = true
                      this.callWait = false
                      this.showEndCall = false
                      this.callStatus = "Máy bận"
                      csVoice.isCallout = false
                      // Bus.$emit('check-retry-call')
                      if (this.contactId) {
                        ContactRepository.additionToNumberOfCall(this.contactId, this.store)
                        ContactRepository.createContactHistory({
                          action: 'APPOINTMENT',
                          description: `${this.isAutoCall ? '(AutoCall) ' : ''}Thực hiện cuộc gọi lỡ.`,
                          contactId: this.contactId,
                          typeCall: this.isDefaultAuto ? 'auto' : this.selectedCallOptions && this.selectedCallOptions.type == 'auto' ?
                            'auto' : 'manual'
                        }, this.contactId)
                      }
                      // Gọi api set máy lẻ free
                      ContactRepository.updateStatusExtForUser({
                        callcenterId: this.callCenterIdFromApiExt,
                        status: FREE,
                        ext: this.currentExt,
                        groupId: this.currentGroupId
                      })
                    }
                    if (newVal === 'error' || newVal === 'failed'){
                      this.endSession();
                    }
                  } catch ({name, message}) {
                    const errorTrace = {
                      error: {name, message},
                      time: new Date(),
                      href: location.href,
                      contact: this.contactData,
                      userId: _.get(TokenService.getUser(), 'id', 0),
                    }
                    ContactRepository.saveLogTraceBug({
                      content: JSON.stringify(errorTrace),
                    });
                  }
                }
            },
            minutes: {
              handler(newVal) {
                if (newVal >= 10 && !this.isInTheSameCall){
                  this.warningTenMinutesCall = true;
                  setTimeout(() =>{
                    this.warningTenMinutesCall = false;
                    this.isInTheSameCall = true;
                  }, 6000)
                }
                if(newVal == '00' && this.isInTheSameCall){
                  this.isInTheSameCall = false;
                }
              }
            },
        },
        async created() {
          this.startSpeechToTxt();
          let user = TokenService.getUser()
            if (this.isNormalCall){
              if (_.get(TokenService.getUser(), 'ext', '') || _.get(TokenService.getUser(), 'extPassword', '')) {
                if (user.callcenter_id == 1) {
                  // this.connectePacific()
                }
                // if (user.callcenter_id == 2) {
                //   let token = csGetCookie(_.get(TokenService.getUser(), 'ext', ''))
                //   let csInCall = localStorage.getItem('csInCall')
                //   if(csInCall == 1) {
                //     // this.$swal({
                //     //     title: 'Tính năng gọi của trang này đã bị ngắt.',
                //     //     showConfirmButton: false,
                //     //     width: '500'
                //     // })
                //     return
                //   }
                //   if(token){
                //     csInit(token, process.env.VUE_APP_CARESOFT_DOMAIN)
                //     setTimeout(async () => {
                //       if(isExpiredCSToken){
                //         // let res = await CallRepository.loginCareSoft({ipphone: '28029002'})
                //         let res = await CallRepository.loginCareSoft({ipphone: '' + _.get(TokenService.getUser(), 'ext', '')})
                //         if (res.message == 'Success') {
                //           token = res.data.token
                //           csSetCookie(token, _.get(TokenService.getUser(), 'ext', ''))
                //           csInit(token, process.env.VUE_APP_CARESOFT_DOMAIN)
                //         } else {
                //           return
                //         }
                //       }
                //     }, 2000);
                //   }
                //   else{
                //     let res = await CallRepository.loginCareSoft({ipphone: '' + _.get(TokenService.getUser(), 'ext', '')})
                //     if (res.message == 'Success') {
                //       token = res.data.token
                //       csSetCookie(token, _.get(TokenService.getUser(), 'ext', ''))
                //       csInit(token, process.env.VUE_APP_CARESOFT_DOMAIN)
                //     } else {
                //       return
                //     }
                //   }
                //   // if (token == '' || isExpiredCSToken) {
                //   //     // let res = await CallRepository.loginCareSoft({ipphone: '28029002'})
                //   //     let res = await CallRepository.loginCareSoft({ipphone: '' + _.get(TokenService.getUser(), 'ext', '')})
                //   //     if (res.message == 'Success') {
                //   //         token = res.data.token
                //   //         csSetCookie(token, _.get(TokenService.getUser(), 'ext', ''))
                //   //     } else {
                //   //         return
                //   //     }
                //   // }
                //   // csInit(token, process.env.VUE_APP_CARESOFT_DOMAIN)
                //   setTimeout(() => {
                //     if (csVoice.callStatus != 'Online') {
                //       changeCallStatus()
                //     }
                //   }, 3000)
                // }
                if (user.callcenter_id == 4) {
                  // const user = {
                  //   username: _.get(TokenService.getUser(), 'ext', ''),
                  //   password: _.get(TokenService.getUser(), 'extPassword', ''),
                  // };
                  // odsService.connectOds(user);
                }
              } else {
                this.errorMessage = 'Cuộc gọi không thành công do thiếu số máy lẻ và mật khẩu máy lẻ !'
                return
              }
            }
            Bus.$on('voice-call-show-popup', async (data, ext = null, password = null, value = null) => {
                // trong trường hợp popup đang mở sẽ không làm gì, nếu không thì show popup và thực hiện cuộc gọi
                this.contactData = data;
                console.log('Bus on voice-call-show-popup data, ext, password, valuevalue: ', data, ext, password, value)
                if(this.showModal) {
                  this.closePopupVoiceCall()
                }
                if (data.mainId) {
                    let self = this
                    this.$swal({
                        title: 'Số điện thoại đã được gộp vào contact ' + data.mainMobile + '.<br>Vui lòng thực hiện các thao tác tại contact chính.',
                        confirmButtonText: 'Xem contact chính',
                        showCancelButton: true,
                        cancelButtonText: 'Quay lại'
                    }).then((res) => {
                        if (res.value) {
                            let routeData = self.$router.resolve({
                                name: 'ContactDetail',
                                params: {
                                    id: data.mainId || 0
                                }
                            })
                            window.open(routeData.href, '_blank')
                        }
                    })
                } else if (!MOBILE_REGEX.test(data.mobile) && !value) {
                  this.$swal({
                    title: 'Số điện thoại không đúng định dạng.',
                    width: 500
                  });
                } else {
                    if (!this.showModal) {
                        window.callStatusCareSoft = ''
                        this.mobile = data.mobile
                        this.dataAppointment = data.dataAppointment
                        this.appointmentId = data.appointmentId
                        this.showCreateAppointment = data.showCreateAppointment
                        this.contactId = data.contactId
                        this.callcenter_id = data.callcenter_id ? data.callcenter_id : 1
                        this.store = data.store ? data.store : ''
                        this.executeCall(ext, data);
                    }
                    this.initData()
                }
            })
            Bus.$on('close-popup-confirm', () => {
                this.closeConfirm()
            })
            Bus.$on('stop-auto-call', () => {
              this.closeModal()
            })
            Bus.$on('cs-voice-disabled', () => {
                if (!csVoice.enableVoice) {
                    this.$swal({
                        title: 'Cuộc gọi chỉ thực hiện tại 1 tab.<br>Nếu bấm kích hoạt cuộc gọi tab cũ sẽ bị ngắt.',
                        confirmButtonText: 'Kích hoạt',
                        showCancelButton: true,
                        cancelButtonText: 'Hủy',
                        width: '580px'
                    }).then(res => {
                        if (res.value) {
                            if (!csVoice.enableVoice) {
                                csEnableCall()
                            }
                        }
                    })
                }
            })
            Bus.$on('init-care-soft-call-center',async (ext, data) => {
              console.log('init-care-soft-call-center ext, data: ', ext, data)
              this.closePopupVoiceCall();
              if (!csUser || !csUser.agent_id) {
                await this.initCareSoft(ext, data)
              }
              setTimeout(() => {
                console.log('initCareSoft() ext: ', ext);
                Bus.$emit('voice-call-show-popup', data, ext, null)
              }, 500)
            });
            // Đóng popup khi click gọi mà popup đang mở
            Bus.$on('close-popup-voice-call', () => {
              this.closePopupVoiceCall()
            })
            window.addEventListener('scroll', this.scrollModalCall);
            window.addEventListener('beforeunload', this.endCall)
        },
        beforeDestroy() {
          this.endCall()
          Bus.$off('close-popup-confirm')
          Bus.$off('stop-auto-call')
          Bus.$off('init-care-soft-call-center')
          window.removeEventListener('scroll', this.scrollModalCall);
          Bus.$off('close-popup-voice-call');
        },
        computed: {
          ...mapState(['isAutoCall','isCallWithBrandName', 'selectedCallOptions', 'isInitOds', 'isInitCareSoft', 'isDefaultAuto','module']),
          isNormalCall(){
            const user = TokenService.getUser();
            return this.checkAuthorization('auto-call_read') || user.username === 'tructoi' || user.username === 'tructoi_caresoft' || user.username === 'Tructongdai_ODS' || user.callcenter_id == 1 || !this.isCallWithBrandName
          },
        },
        methods: {
          maskedPhoneNumber,
          startSpeechToTxt() {
            window.SpeechRecognition =
                window.SpeechRecognition ||
                window.webkitSpeechRecognition;
            this.recognition = new window.SpeechRecognition();
            this.recognition.lang = this.lang_;
            this.recognition.interimResults = true;
            this.recognition.continuous = true;
            this.recognition.addEventListener("nomatch", (event) => {
              console.log(event, 'no match')
            });
            this.recognition.addEventListener("soundstart", (event) => {
              console.log('sound start');
            });
            this.recognition.addEventListener("error", (event) => {
              console.log('error', event);
            });
            this.recognition.addEventListener("soundend", (event) => {
              console.log('soundend');
            });
            this.recognition.addEventListener("start", (event) => {
              console.log('start recognition');
            });
            this.recognition.addEventListener("audioend", (event) => {
              console.log('audioend');
            });
            this.recognition.addEventListener("audiostart", (event) => {
              console.log('audiostart');
            });
            this.recognition.addEventListener("result", event => {
              var text = Array.from(event.results)
                  .map(result => result[0])
                  .map(result => result.transcript)
                  .join(".");
              this.runtimeTranscription_ = text;
            });
            // end of transcription
            this.recognition.addEventListener("end", (e) => {
              console.log('end', e);
              // clearInterval(this.saveLogInterval);
              this.saveLogCall(this.runtimeTranscription_);
              this.runtimeTranscription_ = '';
              if (!this.userEndCall) {
                this.startSpeechToTxt();
                this.startRecordingSpeech();
              } else {
                this.uuid = uuidv1();
              }
              // this.recognition.start()
            });
          },
          startRecordingSpeech() {
            // List test log call
            this.userEndCall = false;
            const user = TokenService.getUser();
            if (USERS_SAVE_LOG.includes(user.id)) {
              if (this.uuid === '') {
                this.uuid = uuidv1();
              }
              // if (this.saveLogInterval) {
              //   clearInterval(this.saveLogInterval);
              // }
              // setInterval(() => {
              //   console.log(this.uuid);
              // }, 1000)
              // this.saveLogInterval = setInterval(() => {
              //   this.recognition.stop();
              //   this.uuid = uuidv1();
              //   this.saveLogCall(this.runtimeTranscription_);
              //   this.runtimeTranscription_ = '';
              //   this.startSpeechToTxt();
              //   this.recognition.startRecordingSpeech();
              // }, 1000 * 5)
              this.recognition.start();
            }
          },
          async saveLogCall(text){
            if(text){
              let user = TokenService.getUser();
              let data = {
                uuid: this.uuid,
                user_id: user.id,
                user_name: user.username,
                log: text,
                sipCallId: this.currentSipCallId,
                callcenter_id: user.callcenter_id,
                time_call: this.timeCallStart,
                phone: this.mobile,
              }
              let res = await ContactRepository.saveLogCall(data)
              if(res.success){
                console.log('Save log success');
              } else {
                console.log('Save log fail');
              }
            }
          },
          setIsInCallLocal(status) {
            localStorage.setItem('isInCall', status.toString())
          },
          getIsInCallLocal() {
            return localStorage.getItem('isInCall') || 'false'
          },
          ...mapMutations(['SET_AUTO_CALL_STATE','SET_IS_INIT_CARE_SOFT']),
            scrollModalCall(event) {
                let defaulPopup = document.querySelector('.s-popup-call')
                if (defaulPopup) {
                    let distance = window.scrollY + 'px';
                    defaulPopup.style.top = `calc(81vh + ${distance})`
                }
                let warningCallPopup = document.querySelector('.s-popup-warning-call')
                if (warningCallPopup) {
                  let distance = window.scrollY + 'px';
                  warningCallPopup.style.top = `calc(5vh + ${distance})`
                }
            },
            initData() {
                this.callError = false,
                this.callAgain = false
            },
            closeConfirm() {
                this.showConfirm = false
            },
            closeModal () {
                if (this.isAutoCall){
                  this.SET_AUTO_CALL_STATE(false);
                }
                // this.showPopupCall = false
                try {
                    this.showTimer = false
                    this.minutes = '00'
                    this.seconds = '00'
                    this.$store.dispatch('SET_CALL_OUT', 0)
                    this.endSession()
                }
                catch(e) {
                    console.log(e)
                }
                finally {
                    this.showModal = false;
                    this.mobile = '';
                    this.appointmentId = 0;
                    // if (this.callcenter_id == 1) {
                    //     this.incomingCall()
                    // }
                }
            },
            endSession() {
                this.isInCall = false
                if (this.session_call) {
                    this.session_call.terminate()
                    this.session_call = false
                }
                let user = TokenService.getUser()
                if (user.callcenter_id === 6) {
                  this.endCallSubiz()
                }
                if (this.isNormalCall && user.ext == '') {
                    return
                }                                                                                 //epa is not use in this case
                if ((this.isNormalCall && (!user.callcenter_id || user.callcenter_id == 1 || user.callcenter_id === 4)) || (!this.isNormalCall && this.callCenterIdFromApiExt === 4)) {
                    if (this.session) {
                        try {
                          this.session.terminate();
                        }
                        catch (e) {
                          console.log(e);
                        }
                        this.session = false
                    }
                } else {
                    endCall()
                  if(!this.isNormalCall) {
                    // agentWebPush.close()
                  }
                }
                if (this.isAutoCall){
                  this.callAgain = false
                  setTimeout(()=> {
                    this.showTimer = false
                    this.minutes = '00'
                    this.seconds = '00'
                    this.$store.dispatch('SET_CALL_OUT', 0)
                    this.showModal = false;
                    this.mobile = '';
                    this.appointmentId = 0;
                    Bus.$emit('resume-auto-call')
                  }, 2000)
                }
            },
            endCall() {
                if (this.isAutoCall){
                  this.SET_AUTO_CALL_STATE(false);
                }
                let user = TokenService.getUser()
                if ( user.callcenter_id !== 6) {
                  this.callAgain = true
                }
                this.showEndCall = false
                this.endSession()
            },
            executeCallePacific() {
                const self = this
                this.callAgain = false
                this.showEndCall = false
                this.callSuccessEnd = false
                this.callWait = false
                this.isFinish = false
                console.log('start call, ', this.mobile)
                this.callStatus = 'Bắt đầu gọi ' +  maskedPhoneNumber(this.mobile) + ', đợi trả lời!'
                const remoteAudio = new window.Audio()
                remoteAudio.autoplay = true;
                remoteAudio.volume = 1
                let userLog = TokenService.getUser();
                const eventHandlers = {
                    'registrationFailed': function (e) {
                        console.log('registration failed with cause: ', e)
                        self.callStatus = "Thiết lập cuộc gọi không thành công"
                        self.callAgain = true
                        self.showEndCall = false
                        self.callWait = false
                        self.callError = true
                    },
                    'progress': function (e) {
                        console.log('call is in progress', e)
                        self.callStatus = 'Bắt đầu gọi ' + maskedPhoneNumber(self.mobile) + ', đợi trả lời!'
                        self.callWait = true
                        self.$store.dispatch('SET_IN_CALL', true)
                        self.setIsInCallLocal(true)
                    },
                    'failed': function (e) {
                        console.log('call failed with cause: ', e)
                        self.callStatus = "Cuộc gọi không thành công do " + _.get(e, 'cause')
                        if(_.get(e, 'message.status_code', 0) == 403) { self.callStatus = 'Lỗi xác thực (số máy lẻ và mật khẩu không đúng)'}
                        Bus.$emit('check-retry-call')
                        self.callAgain = true
                        self.showEndCall = false
                        self.callWait = false
                        self.callError = true
                        self.isInCall = false
                        self.$store.dispatch('SET_IN_CALL', false)
                        self.setIsInCallLocal(false)
                        if (e.cause == 'Busy') {
                            self.callStatus = "Cuộc gọi không thành công do máy bận"
                            ContactRepository.additionToNumberOfCall(self.contactId, self.store)
                            ContactRepository.createContactHistory({
                                action: 'APPOINTMENT',
                                description: `${this.isAutoCall ? '(AutoCall) ' : ''}Thực hiện cuộc gọi lỡ.`,
                                contactId: self.contactId
                            }, self.contactId)
                        }
                        if (e.cause == 'Canceled') {
                            ContactRepository.additionToNumberOfCall(self.contactId, self.store)
                            ContactRepository.createContactHistory({
                                action: 'APPOINTMENT',
                                description: `${this.isAutoCall ? '(AutoCall) ' : ''}Thực hiện cuộc gọi lỡ.`,
                                contactId: self.contactId
                            }, self.contactId)
                        }
                        // Unavailable
                        if (e.cause == 'Unavailable') {
                            self.callStatus = "Cuộc gọi không thành công do khách hàng tắt máy"
                            ContactRepository.additionToNumberOfCall(self.contactId, self.store)
                            ContactRepository.createContactHistory({
                                action: 'APPOINTMENT',
                                description: `${this.isAutoCall ? '(AutoCall) ' : ''}Thực hiện cuộc gọi lỡ.`,
                                contactId: self.contactId
                            }, self.contactId)
                        }
                        // Rejected
                        if (e.cause == 'Rejected') {
                            self.callStatus = "Tổng đài hiện đang bận, vui lòng liên hệ lại khách hàng này sau ít phút nữa!"
                            ContactRepository.additionToNumberOfCall(self.contactId, self.store)
                            ContactRepository.createContactHistory({
                                action: 'APPOINTMENT',
                                description: `${this.isAutoCall ? '(AutoCall) ' : ''}Thực hiện cuộc gọi lỡ.`,
                                contactId: self.contactId
                            }, self.contactId)
                        }
                        // Not Found
                        if (e.cause == 'Not Found') {
                            self.callStatus = "Lỗi nhà mạng, vui lòng liên hệ kỹ thuật!"
                            ContactRepository.additionToNumberOfCall(self.contactId, self.store)
                            ContactRepository.createContactHistory({
                                action: 'APPOINTMENT',
                                description: `${this.isAutoCall ? '(AutoCall) ' : ''}Thực hiện cuộc gọi lỡ.`,
                                contactId: self.contactId
                            }, self.contactId)
                        }
                        if (self.isAutoCall && _.get(e, 'cause') !== 'Canceled' &&  _.get(e, 'cause') !== 'User Denied Media Access'){
                          self.endSession();
                        }
                        if (_.get(e, 'cause') === 'User Denied Media Access'){
                            Bus.$emit('remove-is-calling-contact');
                            self.SET_AUTO_CALL_STATE(false);
                        }
                    },
                    'ended':(e) => {
                        clearInterval(self.timer)
                        console.log('Kết thúc cuộc gọi');
                        this.userEndCall = true;
                        self.recognition.stop();
                        let closed = true
                        if (self.callWait) {
                            closed = false
                        }
                        self.callStatus = "Kết thúc cuộc gọi (" + _.get(e, 'cause') + ')'
                        self.callAgain = false
                        self.showEndCall = false
                        self.callWait = false
                        self.confirmAnswer = false
                        self.$store.dispatch('SET_IN_CALL', false)
                        self.setIsInCallLocal(false)
                        if (closed) {
                            ContactRepository.additionToNumberOfCall(self.contactId, self.store)
                            ContactRepository.createContactHistory({
                                action: 'APPOINTMENT',
                                description: `${this.isAutoCall ? '(AutoCall) ' : ''}Thực hiện cuộc gọi thành công`,
                                contactId: self.contactId
                            }, self.contactId)
                            setTimeout(() => {self.closeModal()}, 3000)
                        } else {
                            self.callAgain = true
                        }
                    },
                    'confirmed': function (e) {
                        self.createTimer()
                        console.log('Bắt đầu cuộc gọi...');
                        try {
                          // self.recognition.start()
                          self.timeCallStart = moment().format('YYYY-MM-DD HH:mm:ss');
                          self.startRecordingSpeech();
                        } catch (e) {
                          console.log(e);
                        }
                        self.callStatus = 'Đang bắt đầu cuộc gọi'
                        self.showEndCall = true
                        self.callSuccessEnd = true
                        self.callWait = false
                        self.$store.dispatch('SET_IN_CALL', true)
                        self.setIsInCallLocal(true)
                        Bus.$emit('set-in-call-status')
                    },
                    // 'addstream': function (e) {
                    //     remoteAudio.srcObject = event.stream;
                    // },
                };

                const options = {
                    'eventHandlers': eventHandlers,
                    'mediaConstraints': {'audio': true, 'video': false},
                    'pcConfig':{
                        'rtcpMuxPolicy': 'negotiate',
                        'iceServers':
                        [
                    //      { urls : [ 'stun:stun.l.google.com:19302' ] }
                        ]
                    },

                };
                this.session = this.$store.state.ua.call(this.mobile, options)
                if (_.get(this.session, '_request.call_id', '')) {
                  this.currentSipCallId = _.get(this.session, '_request.call_id', '');
                  try {
                    ContactRepository.saveSipCallId({
                      callCenterId: 1,
                      sipCallId: _.get(this.session, '_request.call_id', ''),
                      mobile: this.mobile,
                      userId: parseInt(TokenService.getId()),
                      url: window.location.href,
                      infoEndUser: {
                        type: 'KH',
                        code: this.contactData.contactCode,
                      }
                    })
                  } catch (e) {
                    console.log(e)
                  }
                }
                // this.session = this.ua.call(this.mobile, options);
                this.session.connection.addEventListener('addstream', function (event) {
                    remoteAudio.srcObject = event.stream;
                });
            },
            acceptCall() {
                let sound = document.getElementById('incomingCallAudio')
                if (sound) {
                    sound.pause()
                    sound.remove()
                }
                if (!this.callcenter_id || this.callcenter_id == 1) {
                    this.confirmAnswer = false
                    this.session_call.answer()
                } else {
                    this.confirmAnswer = false
                    onAcceptCall()
                }
            },
            createTimer() {
                let min = 0
                let sec = 0
                let self = this
                self.showTimer = true
                self.timer = setInterval(function() {
                    sec++
                    if (sec < 10) {
                        self.seconds = '0' + sec
                    } else if (sec == 60) {
                        sec = 0
                        self.seconds = '00'
                        self.minutes = ++min
                    } else {
                        self.seconds = sec
                    }
                }, 1000)
            },
            async executeCallCareSoft(ext = null) {
                console.log('executeCallCareSoft() ext, userExt: ', ext, _.get(TokenService.getUser(), 'ext', ''))
                try {
                  this.csVoice = csVoice;
                  let self = this
                  // let res = await CallRepository.loginCareSoft({ipphone: '' + _.get(TokenService.getUser(), 'ext', '')})
                  window.callStatusCareSoft = ''
                  this.callStatusCareSoft = ''
                  this.statusChange =  setInterval(function() {
                    self.callStatusCareSoft = window.callStatusCareSoft
                  }, 1000)
                  this.callAgain = false
                  this.showEndCall = false
                  this.callSuccessEnd = false
                  this.callWait = true
                  this.confirmAnswer = false
                  this.callStatus = 'Bắt đầu gọi ' +  maskedPhoneNumber(this.mobile) + ', đợi trả lời!'
                  this.errorMessage = ''
                  if (isExpiredCSToken) {
                    let res = await CallRepository.loginCareSoft({ipphone: '' + ext ?? _.get(TokenService.getUser(), 'ext', '')})
                    if (res.message == 'Success') {
                      let token = res.data.token
                      csSetCookie(token, ext ?? _.get(TokenService.getUser(), 'ext', ''))
                      csInit(token, process.env.VUE_APP_CARESOFT_DOMAIN)
                    } else {
                      return
                    }
                    setTimeout(() => {
                      if (csVoice.callStatus != 'Online') {
                        changeCallStatus()
                      }
                    }, 3000)
                    if (!csVoice.enableVoice) {
                      setTimeout(() => {
                        csEnableCall()
                      }, 3000)
                      setTimeout(() => {
                        if (csVoice.isCallout) {
                          csVoice.isCallout = false
                        }
                        csCallout(this.mobile)
                      }, 6000)
                    } else {
                      setTimeout(() => {
                        if (csVoice.isCallout) {
                          csVoice.isCallout = false
                        }
                        csCallout(this.mobile)
                      }, 3000)
                    }
                  }
                  if (!csVoice.enableVoice) {
                    setTimeout(() => {
                      csEnableCall()
                    }, 3000)
                    setTimeout(() => {
                      if (csVoice.isCallout) {
                        csVoice.isCallout = false
                      }
                      csCallout(this.mobile)
                    }, 3000)
                  } else {
                    if (csVoice.isCallout) {
                      csVoice.isCallout = false
                    }
                    csCallout(this.mobile)
                  }
                } catch ({name, message}) {
                  const errorTrace = {
                    error: {name, message},
                    time: new Date(),
                    href: location.href,
                    contact: this.contactData,
                    userId: _.get(TokenService.getUser(), 'id', 0),
                  }
                  ContactRepository.saveLogTraceBug({
                    content: JSON.stringify(errorTrace),
                  });
                }
              // let token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpcHBob25lIjoiMjgwMjkwMDIiLCJpYXQiOjE1OTExNzc3NDd9.1qQQg7abLUEc-vZGjsLPd-fng-nYTPTRgrEQrASwmIo'
                    // // csInit(token, process.env.VUE_APP_CARESOFT_DOMAIN)
                    // setTimeout(() => {
                    //     csEnableCall()
                    // }, 3000)
                    // setTimeout(() => {
                    //     changeDevice(1)
                    // }, 6000)
            },
            async incomingCallCareSoft() {
                let self = this
                // let res = await CallRepository.loginCareSoft({ipphone: '' + _.get(TokenService.getUser(), 'ext', '')})
                window.callStatusCareSoft = ''
                this.callStatusCareSoft = ''
                this.statusChange =  setInterval(function() {
                    self.callStatusCareSoft = window.callStatusCareSoft
                }, 1000)
                if (isExpiredCSToken) {
                    let res = await CallRepository.loginCareSoft({ipphone: '' + _.get(TokenService.getUser(), 'ext', '')})
                    if (res.message == 'Success') {
                        const token = res.data.token
                        csSetCookie(token, _.get(TokenService.getUser(), 'ext', ''))
                    } else {
                        return
                    }
                    await csInit(token, process.env.VUE_APP_CARESOFT_DOMAIN)
                    if (!csVoice.enableVoice) {
                        setTimeout(() => {
                            csEnableCall()
                        }, 3000)
                    }
                }

                if (!csVoice.enableVoice) {
                    csEnableCall()
                }
                this.callAgain = false
                this.showEndCall = false
                this.callSuccessEnd = false
                this.callWait = false
                this.confirmAnswer = true
                this.callStatus = 'Có cuộc gọi tới từ ' +  maskedPhoneNumber(this.mobile)
                this.showModal = true
            },
          async executeCall(extNumber, data) {
            console.log('executeCall() ext, data, this.isNormalCall: ', extNumber, data, this.isNormalCall)
            if (window.cheatMode == true) {
              this.mobile = window.mobile
            }
            if (this.$store.state.isInCall) {
              return
            }
            let user = TokenService.getUser()
            if (user.ext == '' && this.isNormalCall) {
              return
            }
            let sound = document.getElementById('incomingCallAudio')
            if (sound) {
              sound.pause()
              sound.remove()
            }

            if(!this.isNormalCall && (this.selectedCallOptions.type === 'auto' || this.isDefaultAuto)){
              ContactRepository.addBrandNameCallHistory({contactId: this.contactId})
            }

            // xử lý nếu ấn gọi ở popup
            let body = {
              contactId: this.contactId,
              type: this.selectedCallOptions.type,
              brandnameCode: this.selectedCallOptions.brandnameCode ? this.selectedCallOptions.brandnameCode : null,
            }
            let ext = '';
            let password = '';
            let callcenter_id = '';
            let group_id = '';
            let isSetTimeOutAfterInit = false;
            if (!this.isNormalCall && !extNumber) {
              let res = await ContactRepository.getCallInfo(body)
              if (res && res.success) {
                ext = res.data[0].ext;
                password = res.data[0].extPassword;
                callcenter_id = res.data[0].callcenterId;
                group_id = res.data[0].groupId;
              }else {
                if (_.get(res, 'errors.errorCode', null) == 4) {
                  this.$swal({
                    title: 'Thông báo!',
                    text: _.get(res, 'errors.message', null)
                  })
                } else {
                  this.$swal({
                    title: 'Thông báo!',
                    text: 'Chưa có máy lẻ. Vui lòng liên hệ Sale Admin.'
                  })
                }
                return
              };

              if (callcenter_id === 2 && !this.isInitCareSoft){
                console.log('chua init CARE_SOFT')
                isSetTimeOutAfterInit = true;
                await this.initCareSoft(ext, { callcenter_id, ext, group_id });
                // Gọi api set máy lẻ busy
                ContactRepository.updateStatusExtForUser({
                  callcenterId: callcenter_id,
                  status: BUSY,
                  ext: ext,
                  groupId: group_id
                })
              }
              if (callcenter_id === 4 && !this.isInitOds){
                console.log('chua init ODS')
                isSetTimeOutAfterInit = true;
                await Bus.$emit('init-ods-call-center',ext, password, { callcenter_id, ext, group_id });
                // Gọi api set máy lẻ busy
                ContactRepository.updateStatusExtForUser({
                  callcenterId: callcenter_id,
                  status: BUSY,
                  ext: ext,
                  groupId: group_id
                })
              }
              if (callcenter_id === 6) {
                console.log('init SUBIZ not define');
                isSetTimeOutAfterInit = true;
                ContactRepository.updateStatusExtForUser({
                  callcenterId: callcenter_id,
                  status: BUSY,
                  ext: ext,
                  groupId: group_id
                })
              }
            }
            if (extNumber > 0) {
              this.errorMessage = '';
              ext = extNumber
              if (!callcenter_id) {
                callcenter_id = data.callcenter_id;
              }
              if (!group_id) {
                group_id = data.groupId
              }
            }
            this.currentExt = ext ? ext : user.ext;
            this.callCenterIdFromApiExt = callcenter_id;
            this.currentGroupId = group_id;

            if (callcenter_id && callcenter_id == 2) {
              if(isSetTimeOutAfterInit){
                console.log('da init va setTimeout CARE_SOFT');
                setTimeout(() => {
              this.showModal = true
              this.$store.dispatch('SET_CALL_OUT', 1)
              this.executeCallCareSoft(ext)
                }, 500)
              }else{
                // Gọi api set máy lẻ busy
                ContactRepository.updateStatusExtForUser({
                  callcenterId: this.callCenterIdFromApiExt,
                  status: BUSY,
                  ext: this.currentExt,
                  groupId: this.currentGroupId
                })
                this.showModal = true
                this.$store.dispatch('SET_CALL_OUT', 1)
                this.executeCallCareSoft(ext)
              }
              return
            }
            if (callcenter_id && callcenter_id == 4) {
              if(isSetTimeOutAfterInit){
                console.log('da init va setTimeout ODS');
                setTimeout(() => {
                  this.showModal = true
                  this.$store.dispatch('SET_CALL_OUT', 1)
                  this.executeCallOds();
                }, 500)
              }else{
                // Gọi api set máy lẻ busy
                ContactRepository.updateStatusExtForUser({
                  callcenterId: this.callCenterIdFromApiExt,
                  status: BUSY,
                  ext: this.currentExt,
                  groupId: this.currentGroupId
                })
                this.showModal = true
                this.$store.dispatch('SET_CALL_OUT', 1)
                this.executeCallOds();
              }
              return
            }

            if (user.callcenter_id == 1) {
              this.showModal = true
              this.$store.dispatch('SET_CALL_OUT', 1)
              this.executeCallePacific(data)
            }
            if (user.callcenter_id == 2) {
              if(!this.isInitCareSoft) {
                await this.initCareSoft(this.currentExt, { callcenter_id, ext, group_id });
              }
              this.showModal = true
              this.$store.dispatch('SET_CALL_OUT', 1)
              this.executeCallCareSoft();
            }
            // Hiện tại đang không dùng
            if (user.callcenter_id == 3) {
              let url = "https://cloudapi.mptelecom.com.vn/DialByTrunkOMS?trunkName=TrunkVHOC&agentExtension=" + user.ext + "&phoneNum=" + this.mobile + "&queue=Outbound_VH020&agentCode=" + user.ext + "&omsId=123456789"
              axios.get(url)
                  .then((res) => console.log(res))
                  .catch((err) => console.log(err))
            }
            if (user.callcenter_id == 4) {
              this.showModal = true
              this.$store.dispatch('SET_CALL_OUT', 1)
              this.executeCallOds();
            }
            if (user.callcenter_id == 6) {
               this.showModal = true
               this.$store.dispatch('SET_CALL_OUT', 1)
               this.connectSubiz();
            }
          },
            connectePacific() {
                this.socket = new JsSIP.WebSocketInterface(process.env.VUE_APP_CALL_VOICE_URL)
                this.socket.via_transport = "tcp";
                var remoteAudio = new window.Audio();
                remoteAudio.autoplay = true;
                this.configuration = {
                    sockets: [this.socket],
                    uri: `${_.get(TokenService.getUser(), 'ext', '')}@vuihochn155.ccall.vn`,
                    password: _.get(TokenService.getUser(), 'extPassword', ''),
                    session_timers: false,
                    // session_timers_refresh_method: 'invite',
                    register_expires: 600,
                    log: {
                        builtinEnabled: false,
                        level: 3,
                        connector: function (level, category, label, content) {
                            console.log('Log: ', content);
                        }
                    },
                    socket: {
                        uri           : process.env.VUE_APP_CALL_VOICE_URL,
                        via_transport : 'auto',
                    },
                    use_preloaded_route : false,
                    pcConfig: {
                        rtcpMuxPolicy : 'negotiate',
                        iceServers    :
                        [
                            { urls : [ ] }
                        ]
                    }
                };
                this.ua = new JsSIP.UA(this.configuration)
                let self = this
                this.ua.on('connected', function(e){
                    console.log('connected', e);
                });
                this.ua.on('disconnected', function(e){
                    console.log('disconnected', e);
                });
                this.ua.on('registrationFailed', function(ev){
                    alert('Registering on SIP server failed with error: ' + ev.cause);
                    configuration.uri = null;
                    configuration.password = null;
                    // updateUI();
                });
                // this.ua.on('newRTCSession',function(ev){
                //     var newSession = ev.session;
                //     console.log(newSession.direction)
                //     console.log(self.isInCall)
                //     if (self.isInCall) {
                //         newSession.terminate()
                //         return
                //     } else {
                //         self.isInCall = true
                //     }
                //     self.session_call = newSession;

                //     // var completeSession = function(){
                //     //     console.log('completeSession');
                //     //     session = null;
                //     //     incomingCallAudio.pause();
                //     //     // updateUI();
                //     // };
                //     if(self.session_call.direction === 'incoming') {
                //         console.log('stream incoming  -------->');
                //         self.session_call.on('connecting', function() {
                //             console.log('CONNECT');
                //         });
                //         self.session_call.on('peerconnection', function(e) {
                //             console.log('1accepted');
                //             // add_stream();
                //             self.session_call.connection.addEventListener('addstream',function(e) {
                //                 remoteAudio.srcObject = (e.stream);
                //             })
                //         });
                //         self.session_call.on('ended', function(e) {
                //             clearInterval(self.timer)
                //             console.log('Kết thúc cuộc gọi');
                //             let sound = document.getElementById('incomingCallAudio')
                //             if (sound) {
                //                 sound.pause()
                //                 sound.remove()
                //             }
                //             self.callStatus = "Kết thúc cuộc gọi (" + _.get(e, 'cause') + ')'
                //             self.callAgain = false
                //             self.showEndCall = false
                //             self.callWait = false
                //             console.log(self.session_call)
                //             setTimeout(() => {
                //                 self.closeModal()
                //                 // self.showTimer = false
                //                 // self.minutes = '00'
                //                 // self.seconds = '00'
                //                 // self.showModal = false
                //                 // self.incomingCall()
                //             }, 3000)
                //         });
                //         self.session_call.on('failed', function (e) {
                //             let sound = document.getElementById('incomingCallAudio')
                //             if (sound) {
                //                 sound.pause()
                //                 sound.remove()
                //             }
                //             console.log('call failed with cause: ', e)
                //             self.callStatus = "Cuộc gọi lỗi do " + _.get(e, 'cause')
                //             if(_.get(e, 'message.status_code', 0) == 403) { self.callStatus = 'Lỗi xác thực (số máy lẻ và mật khẩu không đúng)'}
                //             self.callAgain = true
                //             self.showEndCall = false
                //             self.callWait = false
                //             self.callError = false
                //             self.confirmAnswer = false
                //             setTimeout(() => {
                //                 self.closeModal()
                //             }, 3000)
                //         });
                //         self.session_call.on('accepted',function(e) {
                //             console.log('accepted')
                //         });
                //         self.session_call.on('confirmed',function(e){
                //             self.createTimer()
                //             console.log('Bắt đầu cuộc gọi...');
                //             self.callStatus = 'Đang bắt đầu cuộc gọi'
                //             self.showEndCall = true
                //             self.callSuccessEnd = true
                //             self.callWait = false
                //         });
                //         // session.answer(options);
                //         // incomingCallAudio.pause();
                //         // remoteAudio.src = window.URL.createObjectURL(e.stream);
                //         var sound      = document.createElement('audio');
                //         sound.id       = 'incomingCallAudio';
                //         sound.controls = 'controls';
                //         sound.loop     = 'loop'
                //         sound.autoplay = 'autoplay'
                //         sound.src      = 'https://freesound.org/data/previews/62/62872_634166-lq.mp3';
                //         sound.type     = 'audio/mpeg';
                //         sound.style    = 'display: none'
                //         document.getElementById('app-bar').appendChild(sound)
                //         self.showEndCall = false
                //         self.callAgain = false
                //         self.callWait = false
                //         self.mobile = self.session_call._remote_identity._uri.user
                //         self.callStatus = 'Đang gọi đến...'
                //         self.showModal = true
                //         self.confirmAnswer = true
                    // }
                    // updateUI();
                // });
                this.ua.start()
            },
            executeCallOds() {
                const self = this
                this.callAgain = false
                this.showEndCall = false
                this.callSuccessEnd = false
                this.callWait = false
                console.log('start call, ', this.mobile)
                this.callStatus = 'Bắt đầu gọi ' +  maskedPhoneNumber(this.mobile) + ', đợi trả lời!'
                let userLog = TokenService.getUser();
                const eventHandlers = {
                    'registrationFailed': function (e) {
                        try {
                          odsService.saveLogsOdsConnect(userLog.id, userLog.lastName + " " + userLog.firstName, 1, window.location.href, self.$store.state.ua.status, e ? e.cause : '');
                        } catch (err) {
                          console.log(err)
                        }
                        console.log('registration failed with cause: ', e)
                        self.callStatus = "Thiết lập cuộc gọi không thành công"
                        self.callAgain = true
                        self.showEndCall = false
                        self.callWait = false
                        self.callError = true
                    },
                    'progress': function (e) {
                        self.currentSipCallId = _.get(e, 'response.call_id', '');
                        console.log('call is in progress', e);
                        self.callStatus = 'Bắt đầu gọi ' + maskedPhoneNumber(self.mobile) + ', đợi trả lời!'
                        self.callWait = true
                        self.$store.dispatch('SET_IN_CALL', true)
                        self.setIsInCallLocal(true)
                    },
                    'failed': function (e) {
                        try {
                          odsService.saveLogsOdsConnect(userLog.id, userLog.lastName + " " + userLog.firstName, 1, window.location.href, self.$store.state.ua.status, e ? e.cause : '');
                        } catch (err) {
                          console.log(err)
                        }
                        Bus.$emit('check-retry-call')
                        console.log('call failed with cause: ', e)
                        self.callStatus = "Cuộc gọi không thành công do " + _.get(e, 'cause')
                        self.callAgain = true
                        self.showEndCall = false
                        self.callWait = false
                        self.callError = true
                        self.isInCall = false
                        self.$store.dispatch('SET_IN_CALL', false)
                        self.setIsInCallLocal(false)
                      if(e && e.message && e.message.status_code){
                        if(_.get(e, 'message.status_code', 0) == 403) { self.callStatus = 'Lỗi xác thực (số máy lẻ và mật khẩu không đúng)'}
                        if (e.message.status_code == 486) {
                            self.callStatus = "Cuộc gọi không thành công do máy bận"
                            ContactRepository.additionToNumberOfCall(self.contactId, self.store)
                            ContactRepository.createContactHistory({
                                action: 'APPOINTMENT',
                                description: `${this.isAutoCall ? '(AutoCall) ' : ''}Thực hiện cuộc gọi lỡ.`,
                                contactId: self.contactId,
                                typeCall: self.isDefaultAuto ? 'auto' : self.selectedCallOptions && self.selectedCallOptions.type == 'auto' ?
                                    'auto' : 'manual'
                            }, self.contactId)
                        }
                        if (e.message.status_code == 408) {
                          self.callStatus = "Cuộc gọi không thành công do người nghe không bắt máy"
                            ContactRepository.additionToNumberOfCall(self.contactId, self.store)
                            ContactRepository.createContactHistory({
                                action: 'APPOINTMENT',
                            description: 'Người nghe không bắt máy.',
                                contactId: self.contactId,
                                typeCall: self.isDefaultAuto ? 'auto' : self.selectedCallOptions && self.selectedCallOptions.type == 'auto' ?
                                  'auto' : 'manual'
                            }, self.contactId)
                        }
                      }
                      if (e.cause == 'Canceled') {
                          ContactRepository.additionToNumberOfCall(self.contactId, self.store)
                          ContactRepository.createContactHistory({
                              action: 'APPOINTMENT',
                              description: `${this.isAutoCall ? '(AutoCall) ' : ''}Thực hiện cuộc gọi lỡ.`,
                              contactId: self.contactId,
                              typeCall: self.isDefaultAuto ? 'auto' : self.selectedCallOptions && self.selectedCallOptions.type == 'auto' ?
                                'auto' : 'manual'
                          }, self.contactId)
                      }
                      if (self.isAutoCall && _.get(e, 'cause') !== 'Canceled' &&  _.get(e, 'cause') !== 'User Denied Media Access') {
                          self.endSession();
                      }
                      if (_.get(e, 'cause') === 'User Denied Media Access') {
                          Bus.$emit('remove-is-calling-contact');
                          self.SET_AUTO_CALL_STATE(false);
                      }
                      // Gọi api set máy lẻ free
                      ContactRepository.updateStatusExtForUser({
                        callcenterId: self.callCenterIdFromApiExt,
                        status: FREE,
                        ext: self.currentExt,
                        groupId: self.currentGroupId
                      })
                    },
                    'ended':(e) => {
                        try {
                          self.userEndCall = true;
                          self.recognition.stop();
                          odsService.saveLogsOdsConnect(userLog.id, userLog.lastName + " " + userLog.firstName, 1, window.location.href, self.$store.state.ua.status, e ? e.cause : '');
                        } catch (err) {
                          console.log(err)
                        }
                        clearInterval(self.timer)
                        console.log('Kết thúc cuộc gọi');
                        let closed = true
                        if (self.callWait) {
                            closed = false
                        }
                        self.callStatus = "Kết thúc cuộc gọi (" + _.get(e, 'cause') + ')'
                        self.callAgain = false
                        self.showEndCall = false
                        self.callWait = false
                        self.confirmAnswer = false
                        self.$store.dispatch('SET_IN_CALL', false)
                        self.setIsInCallLocal(false)
                        if (closed) {
                            ContactRepository.additionToNumberOfCall(self.contactId, self.store)
                            ContactRepository.createContactHistory({
                                action: 'APPOINTMENT',
                                description: `${this.isAutoCall ? '(AutoCall) ' : ''}Thực hiện cuộc gọi thành công`,
                                contactId: self.contactId,
                                typeCall: self.isDefaultAuto ? 'auto' :  self.selectedCallOptions && self.selectedCallOptions.type == 'auto' ?
                                  'auto' : 'manual'
                            }, self.contactId)
                            setTimeout(() => {self.closeModal()}, 3000)
                            // Gọi api set máy lẻ free
                            ContactRepository.updateStatusExtForUser({
                              callcenterId: self.callCenterIdFromApiExt,
                              status: FREE,
                              ext: self.currentExt,
                              groupId: self.currentGroupId
                            })
                        } else {
                            self.callAgain = true
                        }
                    },
                    'confirmed': (e) => {
                        self.createTimer()
                        try {
                          // self.recognition.start()
                          self.timeCallStart = moment().format('YYYY-MM-DD HH:mm:ss');
                          self.startRecordingSpeech();
                        } catch (e) {
                          console.log(e)
                        }
                        self.callStatus = 'Đang bắt đầu cuộc gọi'
                        self.showEndCall = true
                        self.callSuccessEnd = true
                        self.callWait = false
                        self.$store.dispatch('SET_IN_CALL', true)
                        self.setIsInCallLocal(true)
                        Bus.$emit('set-in-call-status')
                    },
                };
                this.session = odsService.execCall(this.mobile, eventHandlers);
                if (_.get(this.session, '_request.call_id', '')) {
                  this.currentSipCallId = _.get(this.session, '_request.call_id', '');
                  try {
                    ContactRepository.saveSipCallId({
                      callCenterId: 4,
                      sipCallId: _.get(this.session, '_request.call_id', ''),
                      mobile: this.mobile,
                      userId: parseInt(TokenService.getId()),
                      url: window.location.href,
                      infoEndUser: {
                        type: 'KH',
                        code: this.contactData.contactCode,
                      }
                    })
                  } catch (e) {
                    console.log(e)
                  }
                }
            },
          async initCareSoft(ext, data) {
            let token = csGetCookie(ext)
            let csInCall = localStorage.getItem('csInCall')
            if (csInCall == 1) {
              return
            }
            if (token) {
              csInit(token, process.env.VUE_APP_CARESOFT_DOMAIN)
              this.SET_IS_INIT_CARE_SOFT(true);
              setTimeout(async () => {
                if (isExpiredCSToken) {
                  // let res = await CallRepository.loginCareSoft({ipphone: '28029002'})
                  let res = await CallRepository.loginCareSoft({ipphone: '' + ext})
                  if (res.message == 'Success') {
                    token = res.data.token
                    csSetCookie(token, ext)
                    csInit(token, process.env.VUE_APP_CARESOFT_DOMAIN)
                    this.SET_IS_INIT_CARE_SOFT(true);
                  } else {
                    return
                  }
                }
              }, 2000);
            } else {
              let res = await CallRepository.loginCareSoft({ipphone: '' + ext})
              if (res.message == 'Success') {
                token = res.data.token
                csSetCookie(token, ext)
                csInit(token, process.env.VUE_APP_CARESOFT_DOMAIN)
                this.SET_IS_INIT_CARE_SOFT(true);
              } else {
                return
              }
            }
            setTimeout(() => {
              if (csVoice.callStatus != 'Online') {
                changeCallStatus()
              }
            }, 3000)
          },
          closePopupVoiceCall() {
            if (!this.showModal) return;
            if (this.isAutoCall) {
              this.SET_AUTO_CALL_STATE(false);
            }
            try {
              this.showTimer = false
              this.minutes = '00'
              this.seconds = '00'
              this.$store.dispatch('SET_CALL_OUT', 0)
              this.endSession()
            } catch (e) {
              console.log(e)
            } finally {
              this.showModal = false;
            }
          },
          endCallSubiz() {
              let mycallid = this.webphone.getCurrentCallId();
              this.webphone.hangupCall(mycallid);
              this.showEndCall = false
              this.callWait = false
              this.callError = true
              this.isInCall = false
              this.$store.dispatch('SET_IN_CALL', false)
              this.setIsInCallLocal(false)
              try {
                this.userEndCall = true;
                this.recognition.stop()
              } catch (e) {
                console.log(e)
              }
              setTimeout(() => {
                if(!this.callWait && !this.showEndCall) {
                  clearInterval(this.subizInint)
                  clearInterval(this.timer)
                  this.callAgain = true
                }
              }, 700);
            },
          connectSubiz() {
            let user = TokenService.getUser()
            if (user.accessTokenSubiz) {
              let access_token = user.accessTokenSubiz
              let fromNumber = user.fromNumber ? user.fromNumber : '841110000262' // số tổng đài
              this.webphone = new SubizWebPhone(access_token)
              this.showTimer = false
              this.minutes = '00'
              this.seconds = '00'
              this.webphone.makeCall(this.mobile, fromNumber)
              this.callAgain = false
              let mycallid = this.webphone.getCurrentCallId();
              this.subizInint = setInterval(() => {this.checkLogSubiz(mycallid, user)}, 500);
              try {
                  ContactRepository.saveSipCallId({
                      callCenterId: 6,
                      sipCallId: mycallid,
                      mobile: this.mobile,
                      userId: parseInt(TokenService.getId()),
                      url: window.location.href,
                      infoEndUser: {
                          type: 'KH',
                          code: this.contactData.contactCode,
                      }
                  })
              } catch (e) {
                  console.log(e)
              }
            } else {
              this.$swal({
                title: 'Thông báo!',
                text: 'Chưa có máy lẻ. Vui lòng liên hệ Sale Admin.'
              })
            }

          },
          checkLogSubiz(mycallid, user) {
            if (!this.webphone) return;
              let call = this.webphone.getCall(mycallid);
              if (!call) return;
              if (call. status === "dialing") {
                this.currentSipCallId = mycallid;
                this.flagHistory = 0
                this.callStatus = 'Bắt đầu gọi ' +  maskedPhoneNumber(this.mobile) + ', đợi trả lời!'
                this.callWait = true
                this.callAgain = false
              }
              if (call.status === "active"){
                if ( !this.showTimer ) {
                  this.showTimer = true
                  this.createTimer()
                  this.callStatus = `Đang bắt đầu cuộc gọi (subiz ${user.callcenter_id}) `
                  try {
                    this.timeCallStart = moment().format('YYYY-MM-DD HH:mm:ss');
                    this.startRecordingSpeech()
                    // this.recognition.start()
                  } catch (e) {
                    console.log(e)
                  }
                  this.showEndCall = true
                  this.callSuccessEnd = true
                  this.callWait = false
                  this.acceptCallStatus = true
                  Bus.$emit('set-in-call-status')
                }
              }
              if (call.status === 'ended') {
                this.flagHistory += 1
                if (call.hangup_code && call.hangup_code !== '') {
                  const userLog = TokenService.getUser()
                  this.callStatus = STATUS_SUBIZ_ENDED[`${call.hangup_code}`] ? STATUS_SUBIZ_ENDED[`${call.hangup_code}`] : 'Cuộc gọi đã kết thúc'
                }
                if (this.contactId && this.flagHistory === 1) {
                  let description = ''
                  if (this.acceptCallStatus) {
                      description = `${this.isAutoCall ? '(AutoCall) ' : ''}Thực hiện cuộc gọi thành công`
                  } else {
                      description = `${this.isAutoCall ? '(AutoCall) ' : ''}Thực hiện cuộc gọi lỡ.`
                  }
                  ContactRepository.additionToNumberOfCall(this.contactId, this.store)
                  ContactRepository.createContactHistory({
                      action: 'APPOINTMENT',
                      description: description,
                      contactId: this.contactId,
                      typeCall: this.isDefaultAuto ? 'auto' : this.selectedCallOptions && this.selectedCallOptions.type == 'auto' ?
                        'auto' : 'manual'
                  }, this.contactId)
                }
                this.endCall()
              clearInterval(this.timer)
              }
          },
        }
    }
</script>
<style lang="scss">
  .btn-callcenter {
    float: right;
    margin: 0 !important;
    position: relative;
    top: -6px;
  }
  .float-right {
    float: right;
  }
  .v-card__actions {
    display: block;
    padding-bottom: 20px;
    overflow: hidden;
  }
  .v-card {
    overflow: hidden;
  }
  .popup-call {
    border: 1px solid #A9A9A9 !important;
  }
  .warning-ten-minutes-call-text{
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 120%;
    text-align: center;
    color: #000000;
    margin-bottom: 0px !important;
  }
  .s-popup-warning-call{
    .v-icon.v-icon {
      font-size: 35px !important;
    }
  }
</style>
